import { render, staticRenderFns } from "./SettingsTwoDirectionPosition.vue?vue&type=template&id=3c02b851&"
import script from "./SettingsTwoDirectionPosition.vue?vue&type=script&lang=js&"
export * from "./SettingsTwoDirectionPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports